import React, { useRef } from "react";
import RootNameInput from "../ui/RootNameInput";
import EditPicButton from "components/General-UI/EditPicButton";
import EfficeIconLarge from "components/General-UI/EfficeIconLarge";
import { useDispatch, useSelector } from "react-redux";
import {
  selectEditRootError,
  selectRootIcon,
  selectRootName,
  selectTryingEditRoot,
  setRootName,
  setPictureFile,
  newRootConfirm,
  selectLinkPage,
  selectRootLink,
  setNewRootModal,
  selectNewlyMadeRoot,
} from "slices/homeStartSlice";
import { MAX_ROOT_EFFICE_NAME } from "constants/constants";
import { goToEffice } from "slices/efficeTreeSlice";
import Upload from "graphics/icons/Upload";
import CopyButton from "../../../ui/CopyButton";

const RootSetup = () => {
  const inputElement = useRef();
  const dispatch = useDispatch();
  const rootName = useSelector(selectRootName);
  const rootIcon = useSelector(selectRootIcon);
  const tryingEditRoot = useSelector(selectTryingEditRoot);
  const editRootError = useSelector(selectEditRootError);
  const linkPage = useSelector(selectLinkPage);
  const rootLink = useSelector(selectRootLink);
  const newlyMadeRoot = useSelector(selectNewlyMadeRoot);

  return (
    <div className="overflow-hidden">
      <div className={`text-nowrap ${linkPage ? "formSlideLeft" : ""}`}>
        <div className="d-inline-block w-100">
          <br></br>
          <RootNameInput
            editRootError={editRootError}
            rootName={rootName}
            setRootName={(name) => {
              if (name.length < MAX_ROOT_EFFICE_NAME) {
                dispatch(setRootName(name));
              }
            }}
          />
          <br></br>
          <input
            style={{ display: "none" }}
            type="file"
            onChange={(e) => {
              dispatch(setPictureFile(e.target.files[0]));
            }}
            ref={inputElement}
            accept="image/*"
          />
          <div className="d-flex justify-content-around">
            <EditPicButton
              disabledOn={tryingEditRoot}
              text="Upload Icon"
              onClick={() => inputElement.current.click()}
            >
              <Upload />
            </EditPicButton>
            <div className="d-grid">
              <EfficeIconLarge rootIcon={rootIcon} rootName={rootName} />
              {rootIcon ? (
                <div
                  className="mx-auto mt-1 d-inline align-middle cursor-pointer"
                  onClick={() => {
                    dispatch(setPictureFile(null));
                  }}
                >
                  Remove
                </div>
              ) : null}
            </div>
          </div>
          <div>
            <br></br>
            <button
              onClick={() => {
                dispatch(newRootConfirm());
              }}
              type="submit"
              className="confirm-button growth-button mt-1"
              disabled={tryingEditRoot}
            >
              {tryingEditRoot ? "Creating..." : "Create"}
            </button>
            <div className="server-response-error">{editRootError}</div>
          </div>
        </div>
        <div className="d-inline-block w-100">
          <div>Share this link with others so they can join:</div>
          <br></br>
          <p className="edit-root-link">{rootLink}</p>
          <br></br>
          <CopyButton textToCopy={rootLink} />
          <div className="edit-root-link-help">
            The link will work for the next 7 days
          </div>
          <button
            onClick={() => {
              goToEffice(newlyMadeRoot.id, true);
              dispatch(setNewRootModal(false));
            }}
            type="submit"
            className="confirm-button business-button mt-1"
          >
            All Done
          </button>
          <div className="server-response-error">{editRootError}</div>
        </div>
      </div>
    </div>
  );
};

export default RootSetup;
